<div class="inputWrap {{theme}}">
  <em *ngIf="selected" class="material-icons" (click)="clear()">cancel</em>
  <em *ngIf="isLoading" class="material-icons loading">rotate_left</em>
  <input #inputRef
    type="text"
    id="input-{{controlKey}}"
    class="au-{{controlKey}}"
    [ngClass]="{'inputError': control?.invalid && control?.touched}"
    [placeholder]="placeholder"
    [formControl]="searchControl"
    (blur)="onBlur()"
  />
</div>